module.exports = __webpack_public_path__ + "bg_panflet_son.1aed9b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/bg_panflet_son.png
// module id = YTGU
// module chunks = 0